import React from 'react'

const OwlArrowPrev = (props: any) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="191.9 245.2 211.4 351.2"
    {...props}
  >
    <path
      fill="currentColor"
      d="M392.9,255.7c-13.9-14-36.6-14-50.5,0c0,0,0,0,0,0l-140,140c-14,13.9-14,36.6,0,50.5c0,0,0,0,0,0l140,140
	c14.1,13.8,36.7,13.6,50.5-0.4c13.7-13.9,13.7-36.2,0-50.1L278.2,420.9l114.7-114.7C406.8,292.3,406.9,269.7,392.9,255.7
	C392.9,255.7,392.9,255.7,392.9,255.7z"
    />
  </svg>
)

export default OwlArrowPrev
